if (!customElements.get('product-featured-bundle')) {
  customElements.define(
    'product-featured-bundle',
    class ProductFeaturedBundle extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.button = this.form.querySelector('button[type="submit"]');
        this.variantSelect = this.form.querySelector('[data-bundle-variant]');
        this.errorMessage = this.form.querySelector('[role="alert"]');
        this.form.addEventListener('submit', this.handleSubmit);
        this.variantSelect?.addEventListener('change', this.handleVariantChange);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.handleSubmit);
        this.variantSelect?.removeEventListener('change', this.handleVariantChange);
      }

      handleVariantChange = () => {
        const option = this.variantSelect.selectedOptions[0];
        if (!option) return;

        const price = this.querySelector('[data-bundle-price]');
        if (price) price.textContent = option.dataset.price;
        this.form.elements.quantity.value = option.dataset.quantity;
        this.button.disabled = option.disabled;

        const requiresPlan = option.dataset.requiresSellingPlan === 'true';
        this.button.hidden = requiresPlan;
        const planLink = this.querySelector('[data-bundle-plan-link]');
        planLink.hidden = !requiresPlan;
        const url = new URL(planLink.href);
        url.searchParams.set('variant', option.value);
        planLink.href = url.toString();
        this.showError();
      };

      showError(message = '') {
        this.errorMessage.textContent = message;
        this.errorMessage.hidden = !message;
      }

      setLoading(loading) {
        this.loading = loading;
        this.button.disabled = loading;
        this.button.classList.toggle('btn--loading', loading);
        this.button.setAttribute('aria-busy', String(loading));
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
        if (this.variantSelect) this.variantSelect.disabled = loading;
      }

      handleSubmit = async (event) => {
        if (this.loading || this.button.disabled || this.button.hidden) {
          event.preventDefault();
          return;
        }

        // Keep the native Shopify form for cart-page mode and without theme JS.
        const theme = window.FoxTheme;
        if (!theme || this.dataset.cartType === 'page' || document.body.classList.contains('cart-template')) return;

        event.preventDefault();
        this.showError();
        const formData = new FormData(this.form);
        const sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
        );
        formData.set('sections', [...new Set(sections)].slice(0, 5).join(','));
        formData.set('sections_url', window.location.pathname);
        this.setLoading(true);

        let added = false;
        try {
          const response = await fetch(`${this.form.action}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            this.showError(typeof result.description === 'string' ? result.description : this.dataset.errorMessage);
            return;
          }
          added = true;

          const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('Cart refresh failed');
          const cart = await cartResponse.json();
          cart.sections = result.sections;
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
          document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: result } }));

          const drawer = document.querySelector('cart-drawer');
          if (drawer?.show) {
            drawer.show(this.button);
          } else {
            window.location.assign(this.dataset.cartUrl);
          }
        } catch (error) {
          if (added) {
            // A refresh failure must not invite the shopper to add the item twice.
            window.location.assign(this.dataset.cartUrl);
          } else {
            this.showError(this.dataset.errorMessage);
          }
        } finally {
          this.setLoading(false);
        }
      };
    }
  );
}
